import { IIconBase } from '..'

const mailIcon = ({
  color = '#333752',
  height = 14,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='1.16675'
        y='2.9165'
        width='11.6667'
        height='8.16667'
        rx='1.16667'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.75 3.5L7 7.58333L12.25 3.5'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default mailIcon
